import cn from 'classnames';
import { HTMLAttributes } from 'react';

import { IPlayButton, PlayButtonSize, PlayButtonType } from './';

const sizeClasses: Record<PlayButtonSize, string> = {
  l: 'w-14 h-14 lg:w-[72px] lg:h-[72px]',
  s: 'w-14 h-14',
};

const sizeClassesLabel: Record<PlayButtonSize, string> = {
  l: 'style-heading-xxs ml-14 lg:ml-[72px] relative top-[6px] lg:top-[10px]',
  s: 'text-size12 ml-14',
};

const typeClasses: Record<PlayButtonType, string> = {
  light: 'text-black',
  dark: 'text-white',
};
const typeClassesButton: Record<PlayButtonType, string> = {
  light: 'bg-black',
  dark: 'bg-white',
};
const typeClassesSpan: Record<PlayButtonType, string> = {
  light: 'border-l-white',
  dark: 'border-l-black',
};
export function PlayButton(props: IPlayButton & HTMLAttributes<HTMLElement>) {
  const { className, type = 'light', children, size, ...rest } = props;
  return (
    <>
      <div className={cn('flex flex-col')}>
        <label
          className={cn(sizeClassesLabel[size], 'font-bold', typeClasses[type])}
        >
          {children}
        </label>
        <button
          {...rest}
          className={cn(
            sizeClasses[size],
            typeClassesButton[type],
            className,
            'relative flex justify-center items-center text-centerfont-bold',
            `text-white font-bold rounded-full duration-300
            hover:bg-50
            active:bg-50
            disabled:text-grey-40 disabled:border-0 disabled:bg-grey-20
            focus:outline focus:outline-6 focus:outline-grey-20
            [&>span]:hover:border-l-white`,
          )}
        >
          <span
            className={cn(
              typeClassesSpan[type],
              'triangle ml-2 border-t-transparent border-b-transparent border-r-transparent duration-300',
            )}
          ></span>
        </button>
      </div>
    </>
  );
}
